import { GetAccessToken, ClaimSet } from "./GoogleAuth";

const projectID = "sue-benepath-pljwhj";
// session-id can apparently be set to an arbitrary value, eg. "abcd1234-abcd-abcd-abcd-abcd12345678".
const serviceAccountEmail = `dialogflow-njnmip@${projectID}.iam.gserviceaccount.com`;
const serviceAccountPrivateKey = `-----BEGIN PRIVATE KEY-----\nMIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCm7ORbRT+Ps48H\nDUXHU+cCMQfBDDhRqXIvOJxf2Zt6PWmkBIG054uTZU9HbHGlIKSr9kA/689zd5uH\n0HOhnFwQOPi7RgaLbuUcdDEVP8wERUq79Rim46Pi5y+JEV5/Q7eRN39mIK2RzwEL\nOrhpZOQQED5FXgHC53/09yC9cXSMzIXRHDRuwB1Z0ewW+FU8xREI/M2WPPraPjhx\n4fxyJYF8vYsMpRxkrONspHvBzu+YOhE2vzS3HI8OuFTPQozukjgh7SCzUT/3OFsX\nv5fXm02/j0aI7/eNKTqty+AolFt6xFgV9ACScmuKtdGkGd2YbhPi275+MgQIU6QB\njiMqNCvXAgMBAAECggEASfwyZK/HMdKkoLwFwwjRmXuQ08QuTCed2Acv7B3flykU\nIyHqOXvtNcnP/zi2EDntMtjE9m/2tVd8pJBESAutFHWj7SFm8jMXMmrffGsX6oap\nzrAeGo5IC+BrBcYgi6jAeolOGr5+H+PPsyH2LaSNnv8MEqPNhQ0lfjZwmPbp8SNX\nnmbzC92H1jbhUH/8m2jUwFCGzxiTxYT7QDyF46iPJ5Srox2fUmUCaxEx8LiJZMeh\niHmpDd6zsuGQadoWiuTZeUPVulPC+Xb5B0SSjPGAP4HqcXMK8oTDT38xpPsNrDV5\n2vP4bO/03zhmdrn0BTPYkTNcDxK1AXWcFaC882N2HQKBgQDfGWy/FkkUxdv4qui0\ntUhOLmMIj0pNkMEMHU9FLnkUUZqJiZEdalqrlFWWkZcRSgInT8sxS4PyXER0SYMy\nI/Gkts23lKgGuEoZt+v9OwdvxVQinmZgYfAaTmGAi0rWH8gJZinBKmVftIwmB1rT\n0oTbz6blLaGdJZdI8/Zhr/EbtQKBgQC/isFd/gqXHqWgp4rxswQbkfkzphMmbomG\n3a5o+/4C7Lt8FlNxQx+pxHki+mRh8d187TaVTvtjqFrYWDbdxvG94jQJsaa48SVy\noiCElmGqa6MfaM/6Rs50Hg2A8JZchrOvupnUTRDuG7a5JM3tAo9U0reDyJ5uhnTn\nFUnKH0aY2wKBgBO4ap1leeZFKxGLAfDfSVnnzcc260l57yaD/LrPxdIe+HsJ1vLz\nsLoT7ZDWo7TahuA0tHBSDYLB1yc0TE2FUdnOcta0ZDnb1mj5kfmbWyftGGfK+p+w\naInavdGf/mh4/LSf/Dbf6YARNIY0BjpNFINdkpIVe4Cpjvra3b96zuQ1AoGAWgDO\nSedUfJwnAa2YiWgv9vCJo65W80kfkGLcUHKQcjlhA7bN8Lu0xiYPMdNsleV7yPcC\nHfimAbcbMOuKpH2WHD6Nazyx9ddCXHI4S3UKYXUAioLKr3TUEBYLDFqAnOuixWEu\nZWbtHKWjH65eoQ8B4L6/AsqjP5YommkTakl1998CgYEAvrrtqQKH14MSzMN/y5VX\nd8nf+sBZPGgS4/F/6zF+5ImqYV18Ly+ltsoOqRUAfHhvnDPFOudzhXiNPp+wHiiR\nWoASH3GpKp208Dt/IWpEp3aNdHuktgvf03AnrgElfSHLbRx7pBOnTH2nh6RgZfMr\nv874zic6CM7jGbgdG7pJnB0=\n-----END PRIVATE KEY-----\n`;

export async function SendMessage(
  message: string,
  sessionID: string
): Promise<string> {
  const claimSet = new ClaimSet(
    ["https://www.googleapis.com/auth/cloud-platform"],
    serviceAccountEmail
  );
  const accessToken = await GetAccessToken(claimSet, serviceAccountPrivateKey);

  const response = await fetch(
    `https://dialogflow.googleapis.com/v2beta1/projects/${projectID}/agent/sessions/${sessionID}:detectIntent`,
    {
      method: "POST",
      headers: {
        authorization: `Bearer ${accessToken}`,
        "content-type": "application/json",
      },
      body: JSON.stringify({
        queryInput: {
          text: {
            text: message,
            languageCode: "en-US",
          },
        },
      }),
    }
  );

  const responseJSON = await response.json();

  interface BotResponseMessage {
    text: { text: string };
  }

  return responseJSON.queryResult.fulfillmentMessages.map(
    (i: BotResponseMessage) => i.text.text[0]
  );
}
